// extracted by mini-css-extract-plugin
export default {"loader_container":"MediumLoader_loader_container__mi-8O","loader":"MediumLoader_loader__tJMvg","spinner-c7wet2":"MediumLoader_spinner-c7wet2__ncDZg"};